export default __webpack_public_path__ + "static/media/imeet.08f3854f.png";